document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-year]').forEach((node) => {
    node.textContent = new Date().getFullYear();
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const isDoggo = document.body.classList.contains('product-doggo');
    const stageImage = root.querySelector('.pdp-stage__image');
    root.querySelectorAll('[data-gallery-image]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!stageImage) return;
        stageImage.src = thumb.dataset.galleryImage;
        stageImage.removeAttribute('srcset');
        root.querySelectorAll('[data-gallery-image]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        thumb.setAttribute('aria-pressed', 'true');
      });
    });

    root.querySelectorAll('input[name="id"]').forEach((variant) => {
      variant.addEventListener('change', () => {
        const price = variant.dataset.price;
        const option = variant.nextElementSibling ? variant.nextElementSibling.textContent.replace(/\s+—\s+Sold out$/, '').trim() : '';
        document.querySelectorAll('[data-sticky-option]').forEach((node) => { node.textContent = option; });
        if (!price || isDoggo) return;
        root.querySelectorAll('[data-product-price], [data-button-price]').forEach((node) => { node.textContent = price; });
        document.querySelectorAll('[data-sticky-price], [data-sticky-button-price]').forEach((node) => { node.textContent = price; });
      });
    });

    const variantMapElement = document.querySelector('[data-variant-map]');
    if (variantMapElement) {
      const variantMap = JSON.parse(variantMapElement.textContent);
      const firstColor = root.querySelector('[data-color-picker] [data-color]');
      let selectedColor = firstColor ? firstColor.dataset.color : (variantMap[0] && variantMap[0].color);
      let selectedPack = 'Single';

      const resolve = () => {
        const entry = variantMap.find((variant) => variant.color === selectedColor && variant.pack === selectedPack);
        if (!entry) return;
        const selectedVariant = root.querySelector('[data-selected-variant]');
        if (selectedVariant) selectedVariant.value = entry.id;
        document.querySelectorAll('[data-product-price], [data-button-price], [data-sticky-price], [data-sticky-button-price]').forEach((node) => { node.textContent = entry.price; });
        root.querySelectorAll('[data-product-compare]').forEach((node) => {
          node.textContent = entry.compareAt || '';
          node.hidden = !entry.compareAt;
        });
        const addToCart = root.querySelector('[data-add-to-cart]');
        if (addToCart) addToCart.disabled = !entry.available;
        const quantity = root.querySelector('[data-product-quantity]');
        if (quantity) quantity.value = '1';
      };

      root.querySelectorAll('[data-color-picker] [data-color]').forEach((color) => {
        color.addEventListener('click', () => {
          selectedColor = color.dataset.color;
          root.querySelectorAll('[data-color-picker] [data-color]').forEach((item) => item.classList.toggle('is-selected', item === color));
          resolve();
        });
      });

      root.querySelectorAll('[data-pack]').forEach((tier) => {
        tier.addEventListener('click', () => {
          selectedPack = tier.dataset.pack;
          root.querySelectorAll('[data-pack]').forEach((item) => item.classList.toggle('is-selected', item === tier));
          resolve();
        });
      });

      resolve();
    }
  });

  document.querySelectorAll('[data-sticky-submit]').forEach((button) => {
    button.addEventListener('click', () => {
      const formButton = document.querySelector('[data-add-to-cart]');
      if (formButton) formButton.click();
    });
  });

  const productHero = document.querySelector('[data-product-root]');
  const stickyCart = document.querySelector('[data-sticky-cart]');
  if (productHero && stickyCart && 'IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      const entry = entries[0];
      stickyCart.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(productHero);
  }

  const cookieBar = document.querySelector('[data-cookie-bar]');
  if (cookieBar) {
    let choice = null;
    try { choice = localStorage.getItem('furstume_consent'); } catch (error) { choice = null; }
    if (!choice) cookieBar.hidden = false;
    cookieBar.querySelectorAll('[data-cookie-choice]').forEach((button) => {
      button.addEventListener('click', () => {
        try { localStorage.setItem('furstume_consent', button.dataset.cookieChoice); } catch (error) { /* local storage can be unavailable */ }
        cookieBar.hidden = true;
      });
    });
  }

  document.querySelectorAll('[data-countdown]').forEach((el) => {
    const target = new Date(el.dataset.countdown).getTime();
    const prefix = el.dataset.countdownPrefix || '';
    if (isNaN(target)) { el.textContent = ''; return; }
    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) { el.textContent = ''; return; }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      el.textContent = prefix + d + 'd ' + h + 'h ' + m + 'm ' + s + 's';
    };
    tick();
    setInterval(tick, 1000);
  });
});
